export default __webpack_public_path__ + "static/logo-web-83d30d0da700034505d6da8e71d205d9.svg";